import { getOnlyNumbers } from './get-only-numbers';

import type { CountryCode } from 'src/constants';

const LOCAL_PREFIX = '0';

export const formatHebrewPhone = (phone: string) => {
  if (!phone) {
    return '';
  }

  const newPhone = getOnlyNumbers(phone);
  return newPhone ? `${newPhone.slice(0, 3)}-${newPhone.slice(3)}` : '';
};

export const formatPhone = (phone: string, countryCode: CountryCode) => {
  if (countryCode === 'il') {
    return getOnlyNumbers(phone).replace(LOCAL_PREFIX, '');
  } else {
    return getOnlyNumbers(phone);
  }
};
